export const HALF_SCORE_RESULT = 0.5;
export const ONE_HUNDRED_PERCENT = 100;
export const SCORE_INDEX = 10;
export const USA_LAYOUT_ICON_SIZE = 12;
export const DEFAULT_LAYOUT_ICON_SIZE = 5.2;
export const FAVORITE_BUTTON_CONTAINER_ICON_SIZE = 24;
export const ADVANCED_CONTAINER_SIZE = 20;
export const FavoritePerRow = 3;
export const FavoritePerRowMobile = 1;

export enum MULTIVIEW_CARDS_ROW {
  COUNT_2 = 2,
  // eslint-disable-next-line no-magic-numbers
  COUNT_3 = 3
}
export enum MULTIVIEW_CARDS_VIEW {
  COUNT_2 = 2,
  // eslint-disable-next-line no-magic-numbers
  COUNT_3 = 3
}
